import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  InputAdornment,
  Paper,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate } from 'react-router-dom';

import { signInWithPopup } from "firebase/auth";
import { auth, provider } from '../firebase';
import GoogleIcon from '@mui/icons-material/Google';

const API_BASE = process.env.REACT_APP_API_URL;



export default function LoginPage({ onLogin }) {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async () => {
    if (!username.trim() || !password.trim()) {
      alert("Please enter both Farmer Code and Password.");
      return;
    }
      console.log("Login request payload:", {
        username: username,
        password: password
      });
    try {

      const response = await fetch(`${API_BASE}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          username: username,
          password: password
        })
      });

      const data = await response.json();
      console.log("Login API Response:", data);

      if (response.ok && data.farmer) {
        // ✅ Farmer authenticated
        // onLogin(); // Update auth state
        // navigate("/dashboard"); // Redirect
        localStorage.setItem("farmerData", JSON.stringify(data.farmer)); // ✅ store farmer info
        localStorage.setItem("farmerUsername", username);
        localStorage.setItem("farmerName", data.farmer.name);
        localStorage.setItem("DairyName", data.farmer.dairy_name);
        onLogin();
        // navigate("/dashboard");
        navigate("/passbook");
      } else {
        // ❌ Invalid credentials or other error
        alert(data.error || "Login failed. Please try again.");
      }
    } catch (error) {
      console.error("Login request error:", error);
      alert("Unable to connect to the server. Please try again later.");
    }
  };


    const handleGoogleLogin = async () => {
      if (!username.trim()) {
        alert("Please enter your Farmer Code before signing in with Google.");
        return;
      }

      try {
        // Step 1: Sign in with Google popup
        const result = await signInWithPopup(auth, provider);
        const email = result.user.email;

        console.log("Signed in with Google:", email);

        // Step 2: Send to backend
        const response = await fetch(`${API_BASE}/google-login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            username: username,  // Farmer code as entered
            google_id: email     // Google email from sign-in
          })
        });

        const data = await response.json();
        console.log("Google Login API Response:", data);

        // Step 3: Handle response
        if (response.ok && data.farmer) {
          localStorage.setItem("farmerData", JSON.stringify(data.farmer)); // ✅ store farmer info
          localStorage.setItem("farmerUsername", username);
          onLogin();
          // navigate("/dashboard");
          navigate("/passbook");
        } else {
          alert(data.error || "Google login failed. Please try again.");
        }
      } catch (error) {
        console.error("Google sign-in error:", error);
        alert("Google Sign-In failed. Please try again.");
      }
    };



  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        height: '100vh',
        width: '100vw',
      }}
    >
      {/* Top/Left Section */}
      <Box
        sx={{
          width: { xs: '100%', sm: '40%' },
          backgroundColor: '#088064ff',
          color: '#fff',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 4,
          textAlign: 'center',
        }}
      >
        {/* <Typography
          variant={isMobile ? 'h6' : 'h5'}
          sx={{ fontWeight: 'bold', mb: 1 }}
        >
          बलभीम सह. व्यावसायिक दूध उत्पादक संस्था मर्यादित बोरगाव
        </Typography> */}

        <Box
          component="img"
          src="/assets/farmer3.png"
          alt="Farmer"
          sx={{
            width: isMobile ? 120 : 200,
            height: isMobile ? 120 : 200,
            borderRadius: '50%',
            objectFit: 'cover',
            mt: 3,
          }}
        />
        <Typography variant="h5" sx={{ mt: 5, fontWeight: 'bold' }}>
          मिल्कप्रो फार्मर लॉगइन
        </Typography>
      </Box>

      {/* Bottom/Right Section */}
      <Box
        sx={{
          width: { xs: '100%', sm: '60%' },
          backgroundColor: '#ffffffff',
          color: '#fb9200ff',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            width: '100%',
            maxWidth: 400,
            borderRadius: 3,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h5"
            sx={{ mb: 3, color: '#004d40', fontWeight: 'bold' }}
          >
            MilkPrO Farmer App
          </Typography>

          <TextField
            fullWidth
            label="Username"
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            label="Password"
            type="password"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
            }}
          />

          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 3, backgroundColor: '#004d40', color: 'white' }}
            onClick={handleLogin}
          >
            LOGIN
          </Button>

          <Typography sx={{ mt: 2, mb: 1 }}>or</Typography>

          <Button
            fullWidth
            variant="outlined"
            startIcon={<GoogleIcon />}
            onClick={handleGoogleLogin}
          >
            Sign in with Google
          </Button>


          <Typography variant="caption" sx={{ mt: 3, display: 'block' }}>
            Developed by e.Sense InfoSolutions
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}